import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-payment-panel-adyen-meal-voucher-sodexo',
  templateUrl: './payment-panel-adyen-meal-voucher-sodexo.component.html',
  standalone: false,
})
export class PaymentPanelAdyenMealVoucherSodexoComponent {
  @Input() clientKey?: string;
  @Input() useTestApi?: boolean;
  @Input() paymentMethodMealVoucherSodexoAvailable = false;
}
